import React, { useCallback, useState } from 'react';
import { ChangeForm } from '@core/js/components/common/ChangeForm';
import { withComponent } from '@core/js/components/hocs/withComponent';
import { useComponentConfig } from '@core/js/hooks/component/useComponentConfig';

import * as hooks from '@core/js/components/main/DynamicChangePassword/hooks';
import * as Types from '@theme/js/components/main/DynamicChangePassword/types';
import { DEFAULT_FORM_NAME } from '@core/js/components/main/DynamicChangePassword/constants';

// @theme
import { Button } from '@core/js/components/common/Button';
import { useTranslations } from '@core/js/hooks/i18n';
import style from './DynamicChangePassword.scss';

export const DynamicChangePasswordBare: React.FC<Types.IChangePasswordProps> = ({
    error,
    form,
    onClose,
    onSuccess,
    isPasFlow,
    showOldPassword,
    isFormVisible = false // @theme
}) => {
    const { formName } = useComponentConfig<Types.IChangePasswordConfig>();

    // #region @theme
    const [isFormVisibleState, setIsFormVisible] = useState(isFormVisible);
    const t = useTranslations();

    const handleSuccess = useCallback(async (newPassword: string) => {
        setIsFormVisible(false);
        onSuccess && await onSuccess(newPassword);
    }, [onSuccess]);

    const changePassword = hooks.useChangePassword({
        onSuccess: handleSuccess,
        onClose
    });

    const changePasswordByPas = hooks.useChangePasswordByPas({
        onSuccess: handleSuccess,
        onClose,
        showOldPassword
    });

    const toggleChangePasswordBlock = useCallback(() => {
        setIsFormVisible((prev) => !prev);
    }, []);

    return (
        <div className={style.changePasswordBlock}>
            {!isFormVisibleState && (
                <Button view="primary" color="success" onClick={toggleChangePasswordBlock}>
                    {t('playtech.mobile.system.forgotPass.changePassword')}
                </Button>
            )}

            {isFormVisibleState && (
                <ChangeForm
                    formError={error}
                    formName={form || formName || DEFAULT_FORM_NAME}
                    onSubmit={isPasFlow ? changePasswordByPas : changePassword}
                />
            )}
        </div>
    );
    // #endregion
};

export const DynamicChangePassword = withComponent({
    tkPrefix: 'playtech.mobile.system.change-password.'
})(DynamicChangePasswordBare);

export default DynamicChangePassword;
